// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

import { Auth, API } from 'aws-amplify';

import { useNavigate } from 'react-router-dom';

import { v4 as uuidv4 } from 'uuid';
// ----------------------------------------------------------------------

const apiName = 'clearMindsHypnotherapy';

const path = '/manager';

const initialState = {
    error: null,
    usersS1: [],
    usersS2: [],
    followers: [],
    friendRequests: [],
    friends: [],
    gallery: [],
    posts: [],
    detailCards: [],
    simpleCards: [],
    profileCards: [],
    totalPages: 1,
    loading: false,
    limit: 10,
    currentPage: 1
};

const slice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
            state.loading = false;
        },

        startLoading(state, action) {
            state.loading = true;
        },
        setCurrentPage(state, action) {
            console.log('action.payload page', action.payload);
            state.currentPage = action.payload;
        },

        // Add User
        addUser(state, action) {
            const users = state.usersS1;
            const userData = action.payload;
            users.unshift(userData);
            state.usersS1 = users;
            state.loading = false;
        },

        // Add User
        editUser(state, action) {
            state.loading = false;
        },

        // GET USERS STYLE 1
        getUsersListStyle1Success(state, action) {
            state.usersS1 = action.payload;
            const l = action.payload.length / state.limit;

            state.totalPages = Math.ceil(l);
            state.loading = false;
        },

        // GET USERS STYLE 2
        getUsersListStyle2Success(state, action) {
            state.usersS2 = action.payload;
        },

        // GET FOLLOWERS
        getFollowersSuccess(state, action) {
            state.followers = action.payload;
        },

        // FILTER FOLLOWERS
        filterFollowersSuccess(state, action) {
            state.followers = action.payload;
        },

        // GET FRIEND REQUESTS
        getFriendRequestsSuccess(state, action) {
            state.friendRequests = action.payload;
        },

        // FILTER FRIEND REQUESTS
        filterFriendRequestsSuccess(state, action) {
            state.friendRequests = action.payload;
        },

        // GET FRIENDS
        getFriendsSuccess(state, action) {
            state.friends = action.payload;
        },

        // FILTER FRIENDS
        filterFriendsSuccess(state, action) {
            state.friends = action.payload;
        },

        // GET GALLERY
        getGallerySuccess(state, action) {
            state.gallery = action.payload;
        },

        // GET POSTS
        getPostsSuccess(state, action) {
            state.posts = action.payload;
        },

        // EDIT COMMENT
        editCommentSuccess(state, action) {
            state.posts = action.payload;
        },

        // ADD COMMENT
        addCommentSuccess(state, action) {
            state.posts = action.payload;
        },

        // ADD REPLY
        addReplySuccess(state, action) {
            state.posts = action.payload;
        },

        // LIKE POST
        likePostSuccess(state, action) {
            state.posts = action.payload;
        },

        // LIKE COMMENT
        likeCommentSuccess(state, action) {
            state.posts = action.payload;
        },

        // LIKE REPLY
        likeReplySuccess(state, action) {
            state.posts = action.payload;
        },

        // GET DETAIL CARDS
        getDetailCardsSuccess(state, action) {
            state.detailCards = action.payload;
        },

        // FILTER DETAIL CARDS
        filterDetailCardsSuccess(state, action) {
            state.detailCards = action.payload;
        },

        // GET SIMPLE CARDS
        getSimpleCardsSuccess(state, action) {
            state.simpleCards = action.payload;
        },

        // FILTER SIMPLE CARDS
        filterSimpleCardsSuccess(state, action) {
            state.simpleCards = action.payload;
        },

        // GET PROFILE CARDS
        getProfileCardsSuccess(state, action) {
            state.profileCards = action.payload;
        },

        // FILTER PROFILE CARDS
        filterProfileCardsSuccess(state, action) {
            state.profileCards = action.payload;
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getUsersListStyle1(email) {
    return async () => {
        const config = {
            // headers: {
            //     Authorization: `Bearer ${token}`
            // }
        };

        try {
            const response = await axios.get('/api/user-list/s1/list');
            const token = (await Auth.currentSession()).getIdToken().getJwtToken();

            // const myInit = {
            //     // OPTIONAL
            //     queryStringParameters: {
            //         // OPTIONAL
            //         email: {
            //             // Pass the email parameter here without encoding
            //             email
            //         }
            //     },
            //     headers: {
            //         Authorization: token
            //     } // OPTIONAL
            // };
            console.log('calling', apiName, path);
            API.get(apiName, '/managers')
                .then((res) => {
                    // Add your code here
                    console.log(res);
                    dispatch(slice.actions.getUsersListStyle1Success(res?.data));
                })
                .catch((error) => {
                    console.log(error);
                    dispatch(slice.actions.hasError(error));
                });

            // const myInit2 = {
            //     headers: {
            //         Authorization: token
            //     } // OPTIONAL
            // };

            // API.get(apiName, '/sub-category', myInit2)
            //     .then((res) => {
            //         // Add your code here
            //         console.log(res);
            //         // dispatch(slice.actions.getUsersListStyle1Success(res));
            //     })
            //     .catch((error) => {
            //         console.log(error);
            //         dispatch(slice.actions.hasError(error));
            //     });
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function editUser(id, data, navigate) {
    return async () => {
        try {
            const token = (await Auth.currentSession()).getIdToken().getJwtToken();
            const updateManager = {
                userId: data.id,
                company: data.company,
                lastName: data.lastName,
                firstName: data.firstName,
                limitOfUsers: data.limitOfUsers,
                usersAdded: data.usersAdded,
                email: data.email,
                validTill: data.validTill
            };
            const myInit = {
                // OPTIONAL
                body: updateManager,
                headers: {
                    Authorization: token
                } // OPTIONAL
            };

            API.patch(apiName, path, myInit)
                .then((res) => {
                    // Add your code here
                    console.log(res);
                    dispatch(slice.actions.editUser());
                    navigate('/');
                })
                .catch((error) => {
                    console.log(error);
                    dispatch(slice.actions.hasError(error));
                });
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function addUser(data, navigate) {
    return async () => {
        try {
            const token = (await Auth.currentSession()).getIdToken().getJwtToken();

            const myInit = {
                // OPTIONAL
                body: data,
                headers: {
                    Authorization: token
                } // OPTIONAL
            };

            API.post(apiName, path, myInit)
                .then((res) => {
                    // Add your code here
                    console.log('res first', res);
                    const myInit2 = {
                        // OPTIONAL
                        body: {
                            id: uuidv4(),
                            managerId: data.id,
                            email: data.email,
                            firstName: data.firstName,
                            lastName: data.lastName
                        },
                        headers: {
                            Authorization: token
                        } // OPTIONAL
                    };
                    API.post(apiName, '/companyUsers', myInit2)
                        .then((res2) => {
                            console.log('res2', res2);
                            dispatch(slice.actions.addUser(data));
                            Auth.signUp({
                                username: `${data.email}`,
                                password: `${data.firstName}-${data.lastName}`,
                                attributes: {
                                    email: data.email,
                                    name: `${data.firstName}  ${data.lastName}`,
                                    'custom:type': 'manager'
                                }
                            })
                                .then(async (e) => {
                                    console.log('user middle', e.UserSub, e.userSub);
                                    const requestInfo = {
                                        headers: {},

                                        body: {
                                            userEmail: data.email,
                                            userName: `${data.firstName}  ${data.lastName}`,
                                            userLanguage: 'en',
                                            userId: e.userSub
                                        }
                                    };
                                    // await Auth.updateUserAttributes(data, {
                                    //     'custom:type': 'manager' // Replace 'groupName' with the name of your group
                                    // });

                                    console.log('requestInfo', requestInfo);
                                    API.post('clearMindsHypnotherapy', '/user', requestInfo)
                                        .then((response) => {
                                            console.log('response 3rd', response);
                                            console.log('navigating');
                                            navigate('/managers');
                                        })
                                        .catch((error) => console.log('this is error in save User data', error.response));
                                })
                                .catch((err) => {
                                    console.log('Auth err', err);
                                });
                        })
                        .catch((error) => {
                            console.log(error);
                            dispatch(slice.actions.hasError(error));
                        });
                })
                .catch((error) => {
                    console.log(error);
                    dispatch(slice.actions.hasError(error));
                });
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function startLoading() {
    return async () => {
        dispatch(slice.actions.startLoading());
    };
}

export function setCurrentPage(page) {
    return async () => {
        dispatch(slice.actions.setCurrentPage(page));
    };
}

export function getUsersListStyle2() {
    return async () => {
        try {
            const response = await axios.get('/api/user-list/s2/list');
            dispatch(slice.actions.getUsersListStyle2Success(response.data.users_s2));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getFollowers() {
    return async () => {
        try {
            const response = await axios.get('/api/followers/list');
            dispatch(slice.actions.getFollowersSuccess(response.data.followers));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function filterFollowers(key) {
    return async () => {
        try {
            const response = await axios.post('/api/followers/filter', { key });
            dispatch(slice.actions.filterFollowersSuccess(response.data.results));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getFriendRequests() {
    return async () => {
        try {
            const response = await axios.get('/api/friend-request/list');
            dispatch(slice.actions.getFriendRequestsSuccess(response.data.friends));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function filterFriendRequests(key) {
    return async () => {
        try {
            const response = await axios.post('/api/friend-request/filter', { key });
            dispatch(slice.actions.filterFriendRequestsSuccess(response.data.results));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getFriends() {
    return async () => {
        try {
            const response = await axios.get('/api/friends/list');
            dispatch(slice.actions.getFriendsSuccess(response.data.friends));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function filterFriends(key) {
    return async () => {
        try {
            const response = await axios.post('/api/friends/filter', { key });
            dispatch(slice.actions.filterFriendsSuccess(response.data.results));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getGallery() {
    return async () => {
        try {
            const response = await axios.get('/api/gallery/list');
            dispatch(slice.actions.getGallerySuccess(response.data.gallery));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getPosts() {
    return async () => {
        try {
            const response = await axios.get('/api/posts/list');
            dispatch(slice.actions.getPostsSuccess(response.data.posts));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function editComment(key, id) {
    return async () => {
        try {
            const response = await axios.post('/api/posts/editComment', { key, id });
            dispatch(slice.actions.editCommentSuccess(response.data.posts));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function addComment(postId, comment) {
    return async () => {
        try {
            const response = await axios.post('/api/comments/add', { postId, comment });
            dispatch(slice.actions.addCommentSuccess(response.data.posts));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function addReply(postId, commentId, reply) {
    return async () => {
        try {
            const response = await axios.post('/api/replies/add', { postId, commentId, reply });
            dispatch(slice.actions.addReplySuccess(response.data.posts));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function likePost(postId) {
    return async () => {
        try {
            const response = await axios.post('/api/posts/list/like', { postId });
            dispatch(slice.actions.likePostSuccess(response.data.posts));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function likeComment(postId, commentId) {
    return async () => {
        try {
            const response = await axios.post('/api/comments/list/like', { postId, commentId });
            dispatch(slice.actions.likeCommentSuccess(response.data.posts));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function likeReply(postId, commentId, replayId) {
    return async () => {
        try {
            const response = await axios.post('/api/replies/list/like', { postId, commentId, replayId });
            dispatch(slice.actions.likeReplySuccess(response.data.posts));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getDetailCards() {
    return async () => {
        try {
            const response = await axios.get('/api/details-card/list');
            dispatch(slice.actions.getDetailCardsSuccess(response.data.users));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function filterDetailCards(key) {
    return async () => {
        try {
            const response = await axios.post('/api/details-card/filter', { key });
            dispatch(slice.actions.filterDetailCardsSuccess(response.data.results));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getSimpleCards() {
    return async () => {
        try {
            const response = await axios.get('/api/simple-card/list');
            dispatch(slice.actions.getSimpleCardsSuccess(response.data.users));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function filterSimpleCards(key) {
    return async () => {
        try {
            const response = await axios.post('/api/simple-card/filter', { key });
            dispatch(slice.actions.filterSimpleCardsSuccess(response.data.results));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getProfileCards() {
    return async () => {
        try {
            const response = await axios.get('/api/profile-card/list');
            dispatch(slice.actions.getProfileCardsSuccess(response.data.users));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function filterProfileCards(key) {
    return async () => {
        try {
            const response = await axios.post('/api/profile-card/filter', { key });
            dispatch(slice.actions.filterProfileCardsSuccess(response.data.results));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
